//
// ███████╗████████╗ █████╗ ████████╗███████╗
// ██╔════╝╚══██╔══╝██╔══██╗╚══██╔══╝██╔════╝
// ███████╗   ██║   ███████║   ██║   █████╗
// ╚════██║   ██║   ██╔══██║   ██║   ██╔══╝
// ███████║   ██║   ██║  ██║   ██║   ███████╗
// ╚══════╝   ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚══════╝
//
const state = {

  backupsTotal: 0

}

//
//  ██████╗ ███████╗████████╗████████╗███████╗██████╗ ███████╗
// ██╔════╝ ██╔════╝╚══██╔══╝╚══██╔══╝██╔════╝██╔══██╗██╔════╝
// ██║  ███╗█████╗     ██║      ██║   █████╗  ██████╔╝███████╗
// ██║   ██║██╔══╝     ██║      ██║   ██╔══╝  ██╔══██╗╚════██║
// ╚██████╔╝███████╗   ██║      ██║   ███████╗██║  ██║███████║
//  ╚═════╝ ╚══════╝   ╚═╝      ╚═╝   ╚══════╝╚═╝  ╚═╝╚══════╝
//
const getters = {

}

//
// ███╗   ███╗██╗   ██╗████████╗ █████╗ ████████╗██╗ ██████╗ ███╗   ██╗███████╗
// ████╗ ████║██║   ██║╚══██╔══╝██╔══██╗╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
// ██╔████╔██║██║   ██║   ██║   ███████║   ██║   ██║██║   ██║██╔██╗ ██║███████╗
// ██║╚██╔╝██║██║   ██║   ██║   ██╔══██║   ██║   ██║██║   ██║██║╚██╗██║╚════██║
// ██║ ╚═╝ ██║╚██████╔╝   ██║   ██║  ██║   ██║   ██║╚██████╔╝██║ ╚████║███████║
// ╚═╝     ╚═╝ ╚═════╝    ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
//
const mutations = {

}

//
//  █████╗  ██████╗████████╗██╗ ██████╗ ███╗   ██╗███████╗
// ██╔══██╗██╔════╝╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
// ███████║██║        ██║   ██║██║   ██║██╔██╗ ██║███████╗
// ██╔══██║██║        ██║   ██║██║   ██║██║╚██╗██║╚════██║
// ██║  ██║╚██████╗   ██║   ██║╚██████╔╝██║ ╚████║███████║
// ╚═╝  ╚═╝ ╚═════╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
//
const actions = {

  /**
     * Start a backup for a site
     *
     * @param commit
     * @param dispatch
     * @param state
     * @param payload
     */
  backup ({ commit, dispatch, state }, payload) {
    commit('progress/setBackupProgress', { siteId: payload, progress: 0 }, { root: true })

    this._vm.axios.get('/api/site/' + payload + '/backup').then(
      response => {
        this._vm.$snotify.info('Backup started successfully')
      }
    ).catch(
      () => {
        commit('progress/resetBackupProgress', payload, { root: true })
        this._vm.$snotify.info('Backup start failed')
      }
    )
  },

  /**
   * Start backup for all selected sites
   *
   * @param commit
   * @param dispatch
   * @param state
   * @param rootState
   */
  backupAllSites ({ commit, dispatch, state, rootState }) {
    rootState.site.siteSelected.forEach((e) => {
      dispatch('backup', e)
    })
    commit('site/unsetSelectAll', {}, { root: true })
  },

  /**
     * Start a site backup and test
     *
     * @param dispatch
     * @param state
     * @param payload
     */
  backupTest ({ dispatch, state }, payload) {
    this._vm.axios.get('/api/site/' + payload + '/backupandtest').then(
      response => {
        let result = {
          'data': response.data.data,
          'context': {
            'source': 'local',
            'type': 'site',
            'site_id': payload
          }
        }

        dispatch('site/updateLocalStore', result, { root: true })
      }
    )
  },

  /**
   * Start a site backup and test
   *
   * @param dispatch
   * @param state
   * @param payload
   */
  backupAndAudit ({ dispatch, state }, payload) {
    this._vm.axios.get('/api/site/' + payload + '/backupandaudit').then(
      response => {
        let result = {
          'data': response.data.data,
          'context': {
            'source': 'local',
            'type': 'site',
            'site_id': payload
          }
        }

        dispatch('site/updateLocalStore', result, { root: true })
      }
    )
  },

  /**
   * Start backup and testing backups for all selected sites
   *
   * @param commit
   * @param dispatch
   * @param state
   * @param rootState
   */
  backupTestAllSites ({ commit, dispatch, state, rootState }) {
    rootState.site.siteSelected.forEach((e) => {
      dispatch('backupTest', e)
    })
    commit('site/unsetSelectAll', {}, { root: true })
  },

  /**
     * start backuptest
     *
     * @param dispatch
     * @param payload
     *
     * @returns {Promise<any>}
     */
  startBackupTest ({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.post('/api/backup/' + payload + '/test')
        .then(response => {
          this._vm.$snotify.info('Backup test started successfully')
        }
        )
        .catch(
          () => {
            this._vm.$snotify.error('Backup test could not be started - try again or contact support')
          }
        )
    })
  }

}

//
// ███████╗██╗  ██╗██████╗  ██████╗ ██████╗ ████████╗
// ██╔════╝╚██╗██╔╝██╔══██╗██╔═══██╗██╔══██╗╚══██╔══╝
// █████╗   ╚███╔╝ ██████╔╝██║   ██║██████╔╝   ██║
// ██╔══╝   ██╔██╗ ██╔═══╝ ██║   ██║██╔══██╗   ██║
// ███████╗██╔╝ ██╗██║     ╚██████╔╝██║  ██║   ██║
// ╚══════╝╚═╝  ╚═╝╚═╝      ╚═════╝ ╚═╝  ╚═╝   ╚═╝
//
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
